import { render, staticRenderFns } from "./PageDetail.vue?vue&type=template&id=2e6cf08b&"
import script from "./PageDetail.vue?vue&type=script&lang=js&"
export * from "./PageDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports